import { render, staticRenderFns } from "./ManagerNewRequestsRowCancellation.vue?vue&type=template&id=84c86532&"
import script from "./ManagerNewRequestsRowCancellation.vue?vue&type=script&lang=js&"
export * from "./ManagerNewRequestsRowCancellation.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports